<template>

  <table class="list-table">
    <tr class="list-header">
      <th width="10%"><span>No</span></th>
      <th width="10%"><span>{{t('Candidate_number')}}</span></th>
      <th width="20%"><span>{{t('Name')}}</span></th>
      <th width="20%"><span>{{t('Download_exam_file')}}</span></th>
      <th width="20%"><span>{{t('taken')}}</span></th>
      <th width="20%"><span>{{t('Upload_answers')}}</span></th>
    </tr>
    <tr class="list-item" v-for="(item, idx) in aplysList" :key="item">
      <td><span>{{ idx + 1 }}</span></td>
      <td><span>{{ item.num }}</span></td>
      <td><span>{{ item.name }}</span></td>
      <td><span :class="item.quizDownYn !== 'Y' ? 'red' : 'black'">{{ lableFile(item.quizDownYn) }}</span></td>
      <td><span :class="item.examAttendYn !== 'Y' ? 'red' : 'black'">{{ lableAttend(item.examAttendYn) }}</span></td>
      <td><span :class="item.answerUploadYn !== 'Y' ? 'red' : 'black'">{{ lableFile(item.answerUploadYn) }}</span></td>
    </tr>
    <tr class="list-item" v-if="aplysList.length <= 0">
      <td colspan="6"><span>{{t('nodata')}}</span></td>
    </tr>
  </table>

</template>

<script setup>

import { useI18n } from 'vue-i18n';
const { t, locale } = useI18n();

const props = defineProps({
  aplysList: {
    type: Array,
    default: () => []
  },
})

const lableFile = (val) => {
  return val === 'Y' ? t('Completed') : t('Incomplete')
}

const lableAttend = (val) => {
  return val === 'Y' ? t('taken') : t('nottaken')
}

</script>
<style lang="scss" scoped>
@import '@/sass/app.scss';

.list-table {
  width: 100%;
  height: 100%;
  margin-bottom: 32px;
}

.list-header {
  box-sizing: border-box;
  font-size: 15px;
  font-weight: 600;
  line-height: 15px;
  letter-spacing: -0.4px;
  color: #111;
  font-family: 'Pretendard';

  th {
    border-top: solid 2px #000;
    border-bottom: solid 1px #e3e3e3;
    padding: 16px 0px;
    vertical-align: middle;
  }

  span {
    width: 100%;
    display: -webkit-inline-box;
    overflow: hidden;
    text-align: center;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-all;
    white-space: normal;
  }
}

.list-item {
  box-sizing: border-box;
  font-size: 15px;
  line-height: 15px;
  color: #666;
  font-family: 'Pretendard GOV';

  td {
    border-bottom: solid 1px #e3e3e3;
    padding: 22px 0px;
    vertical-align: middle;
  }

  span {
    width: 100%;
    display: -webkit-inline-box;
    overflow: hidden;
    text-align: center;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-all;
    white-space: normal;
  }

  span.black {
    color: #666;
  }

  .red {
    color: #f34831;
  }
}
</style>
